/**
 * 값을 사람이 읽는 글자로.
 *
 * ⚠ **2026-08-29 에 스물넷을 걷었다.** 이 파일은 한때 export 스물일곱이었고
 * 그중 셋만 살아 있었다 — 나머지는 2026-08-26 재구축 때 사라진 화면들의
 * 것이었다(감사 기록의 `actionLabel`·`actionColor`, 에이전트 승인의
 * `dangerLabel`·`dangerWhy`·`dangerColor`, 문서 내장의 `docHeadings`·
 * `frontmatterTags`·`headingId`·`folderOf`, 배포 실행의 `smokeLabel`·
 * `smokeColor`·`smokeShowsDetail`, 묶음 배포의 `batchStateLabel` 넷).
 *
 * 2026-10-22 에 위키·배포 시절 도우미 여섯(`shortSha`·`headingId`·`docHeadings`·
 * `frontmatterTags`·`folderOf`·`formatDay`)을 다시 걷었다 — 10-18 기능 축소 뒤 쓰는 곳이 0이다.
 *
 * 되살릴 때는 `69a2dcb` 에서 꺼내라. 지금 없는 화면의 도우미를 미리 두면
 * **무엇이 살아 있는 코드인지 읽는 사람이 알 수 없다.**
 */

/** 날짜와 시각. 목록에서 「언제」를 한 칸에 적을 때. */
export function formatWhen(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString('ko-KR');
}

/**
 * 두 시각 사이. 끝이 없으면 지금까지.
 *
 * 배포는 저장소 하나에 몇 분씩 걸려 초 단위가 의미가 없다. 1분을 넘기면
 * 분으로만 읽는다.
 */
export function elapsed(from: string, to: string | null): string | null {
  const start = new Date(from);
  if (Number.isNaN(start.getTime())) return null;
  const end = to === null ? new Date() : new Date(to);
  if (Number.isNaN(end.getTime())) return null;
  const seconds = Math.max(0, Math.floor((end.getTime() - start.getTime()) / 1000));
  if (seconds < 60) return `${seconds}초`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}분`;
  const hours = Math.floor(minutes / 60);
  return `${hours}시간 ${minutes % 60}분`;
}
